<script>
    import {labels} from "../timelines/main-timeline";
    import {onMount} from "svelte";
    import gsap from "gsap";
    import {mainTimeline} from "../timelines/main-timeline";
    import BlinkingGnosis from "./Elements/BlinkingGnosis.svelte";

    let gnosis;

    const inAnimation = gsap.timeline();
    const gnosisBlinkTimeline = gsap.timeline({repeat: 1, yoyo: true});
    const customerJourneyInTimeline = gsap.timeline();

    const {gnosisEnd, customerJourneyStart} = labels;

    const gnosisSprites = Array.from(new Array(7)).map((_, i) => 'images/Gnosis0' + i + '.png');

    const visible = {
        opacity: 1
    };

    const hidden = {
        opacity: 0
    };

    onMount(() => {

        gnosisSprites.forEach((href) => {
            gnosisBlinkTimeline
                .call(() => {
                    const gnosisImageElement = document.getElementById("blinking-gnosis");
                    gnosisImageElement.setAttribute('href', href);
                }, null, '>+=0.041');
        });

        setInterval(() => {
            if (Math.random() > 0.8) {
                gnosisBlinkTimeline.play(0);
            }
        }, 1000)

        inAnimation
            .set(gnosis, visible)
            .set(gnosis, hidden, 0.1)
            .set(gnosis, visible, 0.2)
            .set(gnosis, hidden, 0.3)
            .set(gnosis, visible, 0.4)


        customerJourneyInTimeline
            .set(gnosis, hidden)
            .set(gnosis, visible, 0.1)
            .set(gnosis, hidden, 0.2)
            .set(gnosis, visible, 0.3)
            .set(gnosis, hidden, 0.4)

        mainTimeline.add(inAnimation, gnosisEnd + '+=0.1');
        mainTimeline.add(customerJourneyInTimeline, customerJourneyStart);
    });

</script>

<div class="gnosis-corner-container">
    <div class=gnosis bind:this={gnosis}>
        <BlinkingGnosis />
    </div>
</div>

<style>
    .gnosis-corner-container {
        width: 100%;
        position: relative;
        height: 1px;
        overflow: visible;
    }

    .gnosis {
        opacity: 0;
        margin: 0 auto;
        position: absolute;
        right: 80px;
        top: -100px;
        transform: scale(0.4);
        transform-origin: right top;
    }


    @media screen and (max-width: 1200px) {
        .gnosis {
            right: 0;
        }
    }

    @media screen and (max-height: 900px) {
        .gnosis {
            top: -170px;
            transform: scale(0.4);
        }
    }

    @media (max-width: 639px) {
        .gnosis {
            top: -70px;
            right: 10px;
            transform: scale(0.12);
        }
    }

    @media screen and (max-height: 799px) {
        .gnosis {
            right: 10px;
            top: -140px;
            transform: scale(0.25);
        }
    }

</style>
